import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CalculationService {
  private apiUrl = 'https://localhost:64725/api/calculation';
  private operationId: string | null = null;

  constructor(private http: HttpClient) {}

  startCalculation(): Observable<any> {
    this.operationId = this.generateOperationId();
    return this.http.get(`${this.apiUrl}/start/${this.operationId}`);
  }

  cancelCalculation() {
    if (this.operationId) {
      return this.http.post(`${this.apiUrl}/cancel/${this.operationId}`, {});
    }
    return null;
  }

  private generateOperationId(): string {
    return Math.random().toString(36).substring(2, 15); // Generate a unique operation ID
  }
}
